import type { FotoDTO } from '@/models/dto/plc/foto-dto'
import type { Photo } from '@/models/types/plc/photo'

const mapToPhoto = (dto: FotoDTO): Photo => {
    return {
        id: dto.id,
        gifUrl: dto.gifUrl ?? undefined,
        name: dto.nome ?? undefined,
        timestamp: dto.timestamp,
    }
}

const mapToFotoDTO = (photo: Photo): FotoDTO => {
    return {
        id: photo.id,
        gifUrl: photo.gifUrl ?? null,
        nome: photo.name ?? null,
        timestamp: photo.timestamp,
    }
}

export { mapToFotoDTO, mapToPhoto }
